<template lang="pug">
.buy-member-modal(v-if="show" :class="{ 'buy-upgrade-show': isUpgrade }")
  //- 持卡升级
  .card-modal-block(v-if="isUpgrade" :class="{ 'upgrade-v2-bg': buyMemberData.upgradePopupImg }")
    .card-modal-v1(v-if="!buyMemberData.upgradePopupImg")
      .main-title
        .card-big-title
          span.main-text-color 升级{{buyMemberData.rideCardInfoDTO.remainDays}}天
          span 单车超级会员
      .middle-block
        .coupon-word
          .coupon-title
            .coupon-name 专属优惠券
            .coupon-redWord 权益加码
          .coupon-card-list
            couponsItems.couponsItems(v-for="(item,index) in couponsList"
              :cardInfo="item"
              :cardBackground="isnew?'https://m.hellobike.com/resource/gallery/43/A9YFJSrN_Group%201707482284.png':'https://m.hellobike.com/resource/helloyun/08345/DEdG303wDg.png'"
              :expanSionBg="'https://m.hellobike.com/resource/helloyun/08345/DEdG303wDg.png'"
              :cardWidth="'0.76rem'"
              :cardHeight="'0.84rem'"
              :index="index"
              :cardClass="'coupons-container'"
              :isHaveExpanSion="false"
              :isnew="isnew")
        .card-word
          .card-title-upgrade
            .card-logo-upgrade 当前单车卡
            .card-name 次月续费后，会发放完整30天卡
          .cadr-main
            myCardTemplate(
              :moduleData="buyMemberData"
            )
    //- 持卡升级2.0
    UpgradePopupV2.card-modal-v2(v-else :buyMemberData="buyMemberData")
    .card-btn
      vipButtonLadder(
        ref="buttonNew",
        :info="buyMemberData",
        :readSign="isRead"
        @open="bayCardHandler",
        @openDialog="openDialog",
        @transTab="getTransTab",
        @isNoReadSign="openRead"
        :time="buyMemberData.couponEndTime || 0"
        :unOpenShowCanBuy="buyMemberData.unOpenShowCanBuy || true"
        :isIndex="true"
        :isUpgrade="true"
        :propVersion="propVersion"
        :hasRemainDays="hasRemainDays"
      )
    .close-btn(@click="closeModal")
      img(:src="closeImg")
  //- 推荐模块、试用版
  .card-modal-block(v-else)
    .main-title
      .card-bigtitle
        span(v-if="isnew") {{rideTrialUpgradeAB==='N'?'续费正式版:':'升级正式版:'}}
        span {{latestTabCode() === 'ebike' ? '助力车' : '单车'}}超级会员
      .card-subtitle-b(v-if="rideTrialUpgradeAB ==='Y'")
        img(src="https://m.hellobike.com/resource/gallery/61/c4PQcSeE_Frame%20(5).png?x-oss-process=image/quality,q_80")
        span 升级后可享以下权益
      .card-subtitle(v-else) {{leftTab[tabCode].subWord}}
    .middle-block
      .card-word
        .card-title
          .card-logo 卡权益
          .card-name 骑行月卡
        .cadr-main
          RideCardTemplate.card-block(
            :type="cardType"
            :propVersion="propVersion"
            :status="'receivable'"
            :isModal="true"
          )
      .coupon-word
        .coupon-title
          .coupon-logo 超值权益
          .coupon-name 专属优惠券
          .coupon-redWord(v-if="isnew&&rideTrialUpgradeAB==='Y'") 权益加码
        .coupon-card-list
          couponsItems.couponsItems(v-for="(item,index) in couponsList"
            :cardInfo="item"
            :cardBackground="isnew?'https://m.hellobike.com/resource/gallery/43/A9YFJSrN_Group%201707482284.png?x-oss-process=image/quality,q_80':'https://m.hellobike.com/resource/helloyun/08345/DEdG303wDg.png?x-oss-process=image/quality,q_80'"
            :expanSionBg="'https://m.hellobike.com/resource/helloyun/08345/DEdG303wDg.png?x-oss-process=image/quality,q_80'"
            :cardWidth="'0.76rem'"
            :cardHeight="'0.84rem'"
            :index="index"
            :cardClass="'coupons-container'"
            :isHaveExpanSion="false"
            :isnew="isnew")
    .card-btn
      vipButtonLadder(
        ref="buttonNew",
        :info="buyMemberData",
        :readSign="isRead"
        @open="bayCardHandler",
        @openDialog="openDialog",
        @transTab="getTransTab",
        @isNoReadSign="openRead"
        :time="buyMemberData.couponEndTime || 0"
        :unOpenShowCanBuy="buyMemberData.unOpenShowCanBuy"
        :isIndex="true"
        :isUpgrade="isUpgrade"
        :propVersion="propVersion"
      )
    .close-btn(@click="closeModal")
      img(:src="closeImg")
  readModal(
    :show="showRead"
    @close="showRead=false"
    @readOk="readOk"
  )
  .shadow(@click="closeModal")
</template>
<script>
import {
  getNoScroll, getTokenAndLocation,
} from '@/utils';
import eventBus from '@/const/eventBus.js';
import config from '@/const/config';
import { env } from '@hb/hbridge';
import {
  buyVipGoods,
  tryTakeOrderStatus,
  getWaitPayOrder,
  closeVipGoods,
} from '@/api/vip';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import Toast from '@/components/toast';
import { CardService } from '@/service/card';
import { getSystemCode } from '@/utils/systemCode';
import { PropVersionMap } from '@/const/vip';
import HighlightText from '@/components/highlight-text.vue';
import TransTab from '../transTab.vue';
import RideCardTemplate from './ride-card-template';
import myCardTemplate from './my-card-template';
import couponsItems from '../coupons-Items.vue';
import { ParamsUtil } from '../../../../../utils/params';
import { couponsData } from '../../utils';
import vipButtonLadder from '../vip-button-ladder.vue';
import { getSource, getTokenAndKey } from '../../../../../utils';
import { ORDER_STATUS, ORDER_TYPE } from '../../../consts';
import readModal from '../read-modal.vue';
import UpgradePopupV2 from './upgrade-popup-v2.vue';

export default {
  components: {
    TransTab,
    RideCardTemplate,
    couponsItems,
    vipButtonLadder,
    myCardTemplate,
    readModal,
    HighlightText,
    UpgradePopupV2,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    buyMemberData: {
      type: Object,
      default: () => {},
    },
    isReadProp: {
      type: Boolean,
      default: false,
    },
    isnew: {
      type: Boolean,
      default: false,
    },
    rideTrialUpgradeAB: {
      type: String,
      default: 'N',
    },
    isUpgrade: {
      type: Boolean,
      default: false,
    },
    propVersion: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      signInfoDTO: {

      },
      showTitleAb: null,
      continuousMounth: {},
      oneMounth: {},
      haveContinuousMounth: null,
      isRead: false,
      transPrice: null,
      env,
      money: '',
      closeImg: 'https://m.hellobike.com/resource/gallery/61/_R0CJDtep6.png?x-oss-process=image/quality,q_80',
      leftTab: {
        bike: {
          title: '单车卡',
          topWord: '单车超级会员',
          subWord: '30天不限次卡+超值权益',
          rightChoose: '单车超级会员',
          logoImg: 'https://m.hellobike.com/resource/gallery/61/h13kA1cY_Group%2057.png?x-oss-process=image/quality,q_80',
        },
        ebike: {
          title: '助力车卡',
          topWord: '助力车超级会员',
          subWord: '30天6次卡+超值权益',
          rightChoose: '助力车超级会员',
          logoImg: 'https://m.hellobike.com/resource/gallery/61/4bjqt8NA_Group%2057%20(1).png?x-oss-process=image/quality,q_80',
        },
      },
      payChannel: '',
      planId: '',
      showRead: false,
      isNba: false,
      payActivityInfo: {},
      curloopIntervalSecond: 0, // 轮询计数器
      orderTimer: null, // 轮询定时器引用
      payingFlag: false, // 正在支付标识符
    };
  },
  inject: ['rideOneCentVersion', 'latestTabCode'],
  computed: {
    tabCode() {
      return this.latestTabCode();
    },
    couponsList() {
      if (this.buyMemberData && this.buyMemberData.propertyDetailDTOS) {
        this.buyMemberData.propertyDetailDTOS.forEach((i) => {
          if (i.vipExtendProperty) {
            // eslint-disable-next-line no-param-reassign
            i.vipExtendProperty = null;
          }
        });
      }
      return couponsData(this.buyMemberData.propertyDetailDTOS, this.tabCode).splice(0, 4);
    },
    hasRemainDays() {
      if (this.buyMemberData
        && this.buyMemberData.rideCardInfoDTO
        && this.buyMemberData.rideCardInfoDTO.remainDays
        && this.isUpgrade) {
        return true;
      }
      return false;
    },
    cardType() {
      if (this.rideOneCentVersion() === PropVersionMap.RIDE_ONE_CENT && !this.isUpgrade) {
        return 'oneCentRide';
      }
      return this.tabCode;
    },
  },
  watch: {
    isReadProp(val) {
      this.isRead = val;
    },
    rideTrialUpgradeAB(val) {
      this.showTitleAb = val;
    },
    show: {
      handler(newVal) {
        if (newVal && this.hasRemainDays && this.isUpgrade) {
          UBT.moduleExpose({
            pageId: 'platform_savemoneycard_page',
            categoryId: 'platform',
            moduleId: 'platform_shengjifucengVIP',
            contentId: 'platform_shengjifucengVIP',
            exposureTimes: 1,
            businessInfo: {},
          });
        }
      },
    },
  },
  mounted() {
  },
  methods: {
    openDialog() {
      this.getWaitPayOrder();
    },
    closeModal() {
      getNoScroll(false);
      this.$emit('update:show', false);
    },
    chooseMember() {

    },
    // eslint-disable-next-line no-unused-vars
    openRead(payChannel = '', planId = '', isNba = false, payActivityInfo = {}) {
      this.payChannel = payChannel;
      this.planId = planId;
      this.isRead = false;
      this.showRead = true;
      this.payActivityInfo = payActivityInfo;
    },
    getTransTab(type, price) {
      this.transType = type;
      if (this.transType !== 60) {
        if (price >= 0 && price !== '-') {
          this.transPrice = price;
        }
      } else {
        this.transPrice = 0;
      }
      this.$emit('transType', this.transType);
    },
    async getWaitPayOrder() {
      const { token } = await getTokenAndKey();
      try {
        const res = await getWaitPayOrder({
          token,
          action: 'aries.vip.order.getWaitPayOrder',
        });
        if (res.data) {
          this.noPayData = res.data;
          UBT.moduleExpose({
            pageId: 'platform_savemoneycard_page',
            categoryId: 'platform',
            moduleId: 'platform_pay_Popup',
            contentId: 'platform_pay_Popup',
            exposureTimes: 1,
            businessInfo: {},
          });
          // this.showNopay = true;
          await this.cancel();
        } else {
          // this.showNopay = false;
        }
      } catch (e) {
        Toast.showError(e);
      }
    },
    async cancel() {
      const { token } = await getTokenAndKey();
      try {
        await closeVipGoods({
          token,
          action: 'aries.vip.order.closeVipGoods',
          orderNo: this.noPayData.orderNo,
        });
        // Toast.show('取消成功');
        this.getData();
      } catch (e) {
        Toast.showError(e);
      }
    },
    getData() {

    },
    readOk() {
      this.isRead = true;
      if (this.buyMemberData.showPopUpWindowType !== 1) {
        let openPrice;
        if (this.transType === 30) {
          // eslint-disable-next-line no-nested-ternary
          openPrice = this.buyMemberData.signInfoDTO ? (this.buyMemberData.signInfoDTO.firstSignPrice >= 0 ? this.buyMemberData.signInfoDTO.firstSignPrice : '-') : '-';
        } else if (this.transType === 60) {
          openPrice = 0;
        } else {
          openPrice = (this.buyMemberData.current >= 0 ? this.buyMemberData.current : '-');
        }
        this.bayCardHandler(null, this.transType, openPrice, this.payChannel, this.planId, this.isNba, this.payActivityInfo);
      } else {
        this.openDialog();
      }
    },
    // eslint-disable-next-line no-unused-vars
    async bayCardHandler(val, num, money, payChannel = '', planId = '', isNba = false, payActivityInfo = {}) {
      if (this.payingFlag) {
        Toast.show('正在支付中，请稍候');
        return;
      }
      this.payChannel = payChannel;
      this.planId = planId;
      this.payActivityInfo = payActivityInfo;
      const { token, cityCode, adCode } = await getTokenAndLocation();
      if (!token) {
        Toast.show('请先登录');
        return;
      }
      let tempMoney = null;
      if (num === 30 || num === 60) {
        tempMoney = money;
      } else {
        tempMoney = this.buyMemberData.current;
      }
      this.money = tempMoney;
      const toPost = {
        cityCode,
        adCode,
        token,
        // ...(this.buyMemberData || {}),
        ...{
          price: tempMoney,
        },
        goodsGuid: this.buyMemberData.goodsGuid,
        systemCode: getSystemCode(),
        orderExtInfo: JSON.stringify({
          rideTrialUpgradeAB: this.rideTrialUpgradeAB,
        }),
        orderOptType: num || 0, // 0：用户正常下单；10:手动续费下单； 30:连续包月下单
      };
      if (this.isUpgrade) {
        toPost.orderExtInfo = JSON.stringify({
          rideTrialUpgradeAB: this.rideTrialUpgradeAB,
          spcCodes: this.buyMemberData.spcCodes,
        });
        toPost.orderOptType = num === 30 ? 90 : 80; // 80:单月下单； 90:连续包月下单 只针对骑行卡升级
      }
      if ((num === 30 || num === 60) && !toPost.price) {
        // eslint-disable-next-line no-console
        CardService.signWithoutPasswordContract().then(() => this.buyGoods(num, toPost, val));
      } else {
        this.buyGoods(num, toPost, val);
      }
    },
    buyGoods(num, toPost, val) {
      if (this.payingFlag) {
        Toast.show('正在支付中，请稍候');
        return;
      }
      this.payingFlag = true;

      buyVipGoods(toPost)
        .then(async (v) => {
          const { token } = await getTokenAndLocation();
          if (v && v.data) {
            const {
              loopIntervalSecond,
              orderNo,
              loopTotalSecond,
              showPopUpWindowType,
            } = v.data;
            if (env.isWechatMini) {
              if (num === 30) {
                // eslint-disable-next-line no-console
                console.log('微信连续包月planid', this.planId);
                // 连续包月
                if (showPopUpWindowType === 1) {
                  await this.getWaitPayOrder();
                  setTimeout(() => {
                    this.payingFlag = false;
                    this.buyGoods(num, toPost, val);
                  }, 10);
                  return;
                }
                CardService.evokePageAndSign(v.data, this.planId);
                return;
              }
              // 直接买一个月
              window.location.href = ParamsUtil.addParams(window.location.href, {
                loopIntervalSecond,
                orderNo,
                loopTotalSecond,
              });
            }
            if (showPopUpWindowType === 1 && (!val || val === 0)) {
              await this.getWaitPayOrder();
              this.payingFlag = false;
              setTimeout(() => {
                this.buyGoods(num, toPost, val);
              }, 10);
            } else if (toPost.price) {
              // eslint-disable-next-line no-lonely-if
              if (num !== ORDER_TYPE.CONTINUOUS_MONTHLY && num !== ORDER_TYPE.UNION_CONTINUOUS_MONTH
              && this.propVersion !== PropVersionMap.RIDE_ONE_CENT
              && (this.rideOneCentVersion && this.rideOneCentVersion()) !== PropVersionMap.RIDE_ONE_CENT) {
                if (toPost.price) {
                  setTimeout(() => {
                    this.payingFlag = false;// 由于buy方法未推进promise状态 拉起比较迅速 所以直接置为没正在支付
                  }, 1000);
                  await CardService.buyMember(v.data)
                    .then(() => {
                      this.searchStatus(
                        {
                          token,
                          orderNo,
                          loopIntervalSecond,
                          loopTotalSecond,
                        },
                        num,
                      );
                    })
                    .catch((e) => {
                      if (e) {
                        Toast.showError(e);
                      }
                    });
                } else {
                  this.searchStatus(
                    {
                      token,
                      orderNo,
                      loopIntervalSecond,
                      loopTotalSecond,
                    },
                    num,
                  );
                }
              } else if (!env.isEasyBikeApp
                && !env.isAlipayBrowser && !env.isAliMP && !env.isWechatMini) {
                const queryRedirectUrl = `https://m.hellobike.com/AppPlatformH5/${config.envUrlMixin}latest/index.html#/vip/v2/transfer`;
                const baseQuery = `redirectUrl=${encodeURIComponent(
                  queryRedirectUrl,
                )}&h5Login=1`;
                const schemeQuery = config.env === 'fat' ? baseQuery : `codeEnv=${config.env}&${baseQuery}`;
                const scheme = `alipays://platformapi/startapp?appId=2017050407110255&page=/pages/index/index&query=${encodeURIComponent(
                  schemeQuery,
                )}`;
                window.location.href = scheme;
              } else {
                let data = { ...v.data };
                if (this.propVersion === PropVersionMap.RIDE_ONE_CENT || (this.rideOneCentVersion && this.rideOneCentVersion()) === PropVersionMap.RIDE_ONE_CENT) {
                  // 一分骑走抖音签约,抖音签约参数
                  const isContinuous = [ORDER_TYPE.CONTINUOUS_MONTHLY, ORDER_TYPE.UNION_CONTINUOUS_MONTH].includes(num);
                  const channel = isContinuous ? '2309' : '2304';
                  const extension = isContinuous
                    ? {
                      planId: '', // 无需传planId，就会有兜底planId
                      signMustPay: true,
                      attachSceneType: 'RIDE',
                    }
                    : {
                      signMustPay: true,
                    };
                  const { productTagForDySign = '', bizScene = '' } = this.payActivityInfo || {};
                  data = {
                    ...v.data,
                    channelOperationInfoExt: {
                      productTagForDySign,
                      biz_scene: bizScene,
                    },
                    channel,
                    extension,
                  };
                } else if (this.payChannel) {
                  data.signChannel = this.payChannel;
                  if (this.planId || env.isWeixin || env.isWechatMini) {
                    data.extension = {};
                    data.extension.planId = this.planId;
                  }
                }
                await CardService.buyContinueMember(data)
                  .then(() => {
                    this.searchStatus(
                      {
                        token,
                        orderNo,
                        loopIntervalSecond,
                        loopTotalSecond,
                      },
                      num,
                    );
                  })
                  .catch((e) => {
                    if (e) {
                      Toast.showError(e);
                    }
                  });
              }
            } else {
              this.searchStatus(
                {
                  token,
                  orderNo,
                  loopIntervalSecond,
                  loopTotalSecond,
                },
                num,
              );
            }
          }
        })
        .catch((e) => {
          Toast.showError(e || '');
        })
        .finally(() => {
          this.payingFlag = false;
        });
    },
    // 轮询付费会员状态
    async searchStatus({
      token, orderNo, loopIntervalSecond = 1, loopTotalSecond = 5,
    }, type) {
      // loopIntervalSecond 轮询间隔时间
      // loopTotalSecond 轮询总时间
      // 重置计数器
      this.curloopIntervalSecond = 0;

      const poll = async () => {
        if (this.curloopIntervalSecond >= loopTotalSecond) {
          if (this.orderTimer) {
            clearTimeout(this.orderTimer);
            this.orderTimer = null;
          }
          return;
        }

        try {
          const { data, msg } = await tryTakeOrderStatus({
            token,
            orderNo,
            systemCode: getSystemCode(),
          });


          if (data) {
            const { status } = data;

            // 订单交易中，继续轮询
            if (status === ORDER_STATUS.padding) {
              this.curloopIntervalSecond += loopIntervalSecond;
              this.orderTimer = setTimeout(poll, loopIntervalSecond * 1000);// 更新timer
              return;
            }

            // 清除定时器
            if (this.orderTimer) {
              clearTimeout(this.orderTimer);
              this.orderTimer = null;
            }

            UBT.clickButton({
              pageId: 'platform_PurchasePage',
              buttonName: 'platform_ToPurchase',
              categoryId: 'platform',
              businessInfo: {
                adsource: getSource(),
                TransactionResults: (() => {
                  if (status === ORDER_STATUS.fall || status === ORDER_STATUS.closed) {
                    return 0;
                  }
                  if (status === ORDER_STATUS.success) {
                    return 1;
                  }
                  return '';
                })(),
              },
            });

            // 订单成功
            if (status === ORDER_STATUS.success) {
              if (this.isnew && !this.isUpgrade) {
                this.$emit('openDialog', type, data);
              } else {
                eventBus.$emit('buyMember', this.buyMemberData.commonBonus, this.money);
              }
              this.closeModal();
            }
            // 订单失败
            if (status === ORDER_STATUS.fall || status === ORDER_STATUS.closed) {
              Toast.show('正在支付中，请稍候查看');
              this.$router.go(-1); // 为什么回退？
            }
          } else {
            // API 调用失败，停止轮询
            if (this.orderTimer) {
              clearTimeout(this.orderTimer);
              this.orderTimer = null;
            }
            Toast.show(msg);
          }
        } catch (error) {
          // 处理异常，停止轮询
          if (this.orderTimer) {
            clearTimeout(this.orderTimer);
            this.orderTimer = null;
          }
          Toast.show('查询订单状态失败');
        }
      };

      // 开始轮询
      this.orderTimer = setTimeout(poll, loopIntervalSecond * 1000);
    },
  },
};
</script>
<style lang="less" scoped>
.buy-member-modal {
  .card-modal-block {
    position: fixed;
    bottom: 0;
    z-index: 222;
    // height: 5.1rem;
    width: 100%;
    background: #fff;
    border-radius: 0.12rem 0.12rem 0.02rem 0.02rem;

    .main-title {
      padding: 0.16rem;
      font-family: PingFang SC, sans-serif;
      font-size: 0.18rem;
      font-weight: 500;
      line-height: 0.252rem;
      background-image: url('https://m.hellobike.com/resource/gallery/61/ml5oExzS_Mask%20group%202.png?x-oss-process=image/quality,q_80');
      background-size: 100% 100%;
      height: 0.77rem;

      .card-subtitle {
        font-family: PingFang SC, sans-serif;
        font-size: 0.12rem;
        font-weight: 400;
        line-height: 0.168rem;
        color: #5a6066;
      }

      .card-subtitle-b {
        width: 1.27rem;
        height: 0.18rem;
        border-radius: 0.09rem;
        background: linear-gradient(90deg, #ffec5f 0%, #ffcd17 100%);
        font-family: DingTalk JinBuTi, sans-serif;
        font-size: 0.12rem;
        font-style: italic;
        font-weight: 400;
        line-height: 0.18rem;
        white-space: nowrap;

        img {
          width: 0.13rem;
          height: 0.13rem;
        }
      }
    }

    .middle-block {
      padding-bottom: 0.08rem;

      .card-word {
        padding-left: 0.18rem;
        padding-right: 0.14rem;

        .card-title {
          display: flex;

          .card-logo {
            width: 0.46rem;
            height: 0.18rem;
            color: #fffae8;
            background: linear-gradient(90deg, #36363c 100%, #625f6a 0%);
            border-radius: 0.08rem 0.02rem 0.08rem 0.02rem;
            font-size: 0.12rem;
            line-height: 0.18rem;
            text-align: center;
          }

          .card-name {
            margin-left: 0.05rem;
            font-family: PingFang SC, sans-serif;
            font-size: 0.14rem;
            font-weight: 400;
            line-height: 0.18rem;
          }
        }

        .cadr-main {
          padding-left: 0.05rem;
          margin-right: 0.09rem;
          margin-top: 0.09rem;

          .card-block {
            border-radius: 0.12rem;
          }
        }
      }

      .coupon-word {
        margin-top: 0.16rem;
        padding-left: 0.18rem;
        padding-right: 0.14rem;

        .coupon-title {
          display: flex;

          .coupon-logo {
            padding: 0 0.04rem;
            height: 0.18rem;
            color: #fffae8;
            background: linear-gradient(90deg, #36363c 100%, #625f6a 0%);
            border-radius: 0.08rem 0.02rem 0.08rem 0.02rem;
            font-size: 0.12rem;
            line-height: 0.18rem;
            text-align: center;
          }

          .coupon-name {
            margin-left: 0.05rem;
            font-family: PingFang SC, sans-serif;
            font-size: 0.14rem;
            font-weight: 400;
            line-height: 0.18rem;
          }

          .coupon-redWord {
            font-family: PingFang SC, sans-serif;
            font-size: 0.14rem;
            font-weight: 500;
            line-height: 0.18rem;
            color: #f54311;
            margin-left: 0.05rem;
          }
        }

        .coupon-card-list {
          display: flex;
          justify-content: space-between;
          padding-left: 0.05rem;
          margin-right: 0.09rem;
          margin-top: -0.02rem;

          .couponsItems {
            margin-top: 0.1rem;
          }
        }

        .cadr-main {
          padding-left: 0.05rem;
          margin-right: 0.09rem;
          margin-top: 0.08rem;
        }
      }
    }

    .card-btn {
      // position: absolute;
      // bottom: 0;
      // height: 1.24rem;
      width: 100%;
      box-shadow: 0 -2px 0.12rem 0 #00000012;
      border-radius: 0.2rem 0.2rem 0 0;

      .one-mouth {
        width: 100%;
        height: 0.48rem;
        border-radius: 0.12rem;
        text-align: center;
        line-height: 0.48rem;
        background: #08f;
        color: #fffaeb;
        margin: 0.16rem auto 0 auto;
        font-size: 0.14rem;
        font-weight: 600;

        span.big-word {
          display: inline-block;
          font-size: 0.2rem;
          font-weight: 700;
          font-family: "DIN Alternate Bold", sans-serif;
          margin: 0 0.02rem;
        }
      }

      .bottom-container {
        position: relative;
      }

      .more-mouth {
        display: flex;
        justify-content: space-between;
        margin-top: 0.16rem;
        text-align: center;

        .more-mouth-one {
          width: 1.45rem;
          height: 0.48rem;
          border: 0.005rem solid #0098ff;
          border-radius: 0.12rem;

          .more-mouth-line-one {
            margin-top: 0.09rem;
            font-family: PingFang SC, sans-serif;
            font-size: 0.14rem;
            font-weight: 500;
            line-height: 19.6px;

            span.blue-small {
              color: #0098ff;
            }

            span.blue-big {
              color: #0098ff;
              font-size: 0.18rem;
              font-weight: 700;
              font-family: "DIN Alternate Bold", sans-serif;
            }
          }

          .more-mouth-line-two {
            font-family: PingFang SC, sans-serif;
            font-size: 0.1rem;
            font-weight: 400;
            line-height: 0.12rem;
            text-decoration: line-through;
            color: #879099;
          }
        }

        .more-mouth-two {
          width: 1.45rem;
          height: 0.48rem;
          border-radius: 0.12rem;
          background: #0098ff;

          .more-mouth-two-one {
            margin-top: 0.04rem;
            color: #fffae8;
            font-weight: 600;
            font-size: 0.14rem;
            line-height: 0.196rem;

            span.big-font {
              font-size: 0.2rem;
              font-family: "DIN Alternate Bold", sans-serif;
              line-height: 0.24rem;
            }
          }

          .more-mouth-two-two {
            font-family: PingFang SC, sans-serif;
            font-size: 0.1rem;
            font-weight: 400;
            line-height: 0.14rem;
            color: #fff;
          }
        }
      }
    }

    &.upgrade-v2-bg {
      background: linear-gradient(334.79deg, #ffcc75 47.9%, #ffe8b8 87.19%);
    }
  }

  .close-btn {
    position: absolute;
    top: 0.14rem;
    right: 0.13rem;

    img {
      width: 0.16rem;
      height: 0.16rem;
    }
  }

  .shadow {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: #000;
    opacity: 0.7;
    z-index: 220;
  }
}

.buy-upgrade-show {
  .card-modal-block {
    .main-title {
      padding: 0.16rem 0.16rem 0.16rem 0.2rem;
      font-family: PingFang SC, sans-serif;
      background: linear-gradient(180deg, rgba(255, 241, 206, 1), rgba(255, 255, 255, 1));
      border-radius: 0.12rem 0.12rem 0 0;
    }

    .middle-block {
      margin-top: -0.2rem;

      .card-word {
        padding-left: 0.2rem;
        margin-top: 0.14rem;

        .card-title-upgrade {
          display: flex;
          align-items: center;
          font-family: PingFang SC, sans-serif;
        }

        .card-logo-upgrade {
          font-weight: 500;
          font-size: 0.14rem;
          color: #242729;
        }

        .card-name {
          font-size: 0.11rem;
          color: #879099;
          margin-left: 0.1rem;
        }
      }

      .coupon-word {
        margin-top: 0.03rem;
        padding-left: 0.2rem;
        padding-right: 0.14rem;

        .coupon-title {
          .coupon-name {
            font-weight: 500;
            font-size: 0.14rem;
            color: #242729;
            margin-left: 0;
          }
        }

        .coupon-card-list {
          padding: 0;
        }
      }
    }
  }

  .main-text-color {
    color: #f54311;
  }
}
</style>
